__turbopack_context__.v({
  "accordionEnter": "Accordion-module__sgaSsG__accordionEnter",
  "accordionEnterActive": "Accordion-module__sgaSsG__accordionEnterActive",
  "accordionExit": "Accordion-module__sgaSsG__accordionExit",
  "accordionExitActive": "Accordion-module__sgaSsG__accordionExitActive",
  "container": "Accordion-module__sgaSsG__container",
  "content": "Accordion-module__sgaSsG__content",
  "title": "Accordion-module__sgaSsG__title",
  "titleIcon": "Accordion-module__sgaSsG__titleIcon",
  "titleOpen": "Accordion-module__sgaSsG__titleOpen",
});
